<template>
	<div class="category-navigation__wrapper" v-if="catChildren.length > 0 && !isFiltered">
		<div class="container-max">
			<div class="row justify-content-center top-row" ref="topRow" :class="{'open': showMore}" :style="'height:' + topRowHeight + 'px'">
				<a :href="mainCat + '/' + child.category.details[0].nameUrl" class="category-navigation__item col-12 col-md-4 col-lg-3" v-for="(child, key) in (showMore || closeCats.length < 4) ? catChildren : closeCats" v-if="(key < (isMobile ? 3 : 4)) && !showAllItems">

					<div class="category-navigation__img-wrapper">
						<img class="category-navigation__img" :src="child.image !== '' ? child.image : '/documents/' + child.category.details[0].imagePath" :alt="child.category.details[0].name" :title="child.category.details[0].name">
					</div>

					<div class="category-navigation__content">
						<div class="category-navigation__name">
							{{ child.category.details[0].name }}
						</div>

						<div class="category-navigation__desc">
							{{ child.category.details[0].shortDescription }}
						</div>
					</div>
				</a>
			</div>

			<div class="row justify-content-center collapse" :class="{'show': showAllItems}" id="collapseExample">
				<a :href="mainCat + '/' + child.category.details[0].nameUrl" class="category-navigation__item col-12 col-md-4 col-lg-3" v-for="(child, key) in catChildren">

					<div class="category-navigation__img-wrapper">
						<img class="category-navigation__img" :src="child.image !== '' ? child.image : '/documents/' + child.category.details[0].imagePath" :alt="child.category.details[0].name" :title="child.category.details[0].name">
					</div>

					<div class="category-navigation__content">
						<div class="category-navigation__name">
							{{ child.category.details[0].name }}
						</div>

						<div class="category-navigation__desc">
							{{ child.category.details[0].shortDescription }}
						</div>
					</div>
				</a>
			</div>

			<div v-if="catChildren.length > 4 && showAllItems === false" class="col-12 category-navigation__button-wrapper">
				<button class="category-navigation__button" :class="{'active': showMore === true}" @click="showMore = !showMore" type="button" data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">

					<span v-if="showMore === false">{{ $translate("HoferAntikschmuck::Template.all") }} {{ mainCatName }}</span>
					<span v-if="showMore === true">{{ $translate("HoferAntikschmuck::Template.showLess") }}</span>

					<svg class="mobile-nav__chevron" fill="currentColor">
						<use xlink:href="#chevron-down" />
					</svg>
				</button>
			</div>
		</div>


		<div v-if="!showAllItems" class="hofer-hr__wrapper">
			<div class="hofer-hr">
				<svg class="mobile-nav__chevron" fill="currentColor">
					<use xlink:href="#logo-minimal" />
				</svg>
			</div>
		</div>
	</div>
</template>

<script>
	export default {

		props: {
			catChildren: Array,
			mainCat: String,
			mainCatName: String,
			showAllItems: {
				type: Boolean,
				default: false,
			}
		},

		data(){
			return {
				showMore: false,
				isMobile: false,
				isFiltered: false,
        topRowHeight: Number,
			}
		},

		mounted() {
			this.isMobile = window.innerWidth < 992
			this.isFiltered = window.location.href.indexOf('facets') > -1;

			window.addEventListener("resize", () => this.isMobile = window.innerWidth < 992 )


      this.$nextTick(() =>
      {
        this.topRowHeight = this.$refs.topRow.clientHeight
      });
		},

    computed: {
      closeCats(){
        let amount = 0
        let mainArray = []

        this.catChildren.forEach(child => {
          if(child.isMain === true){
            mainArray.push(child)
          }
        })

        return mainArray
      }
    }
	}
</script>
